/*
 * ORDER / BULK ORDER tabs, and the retail add-to-cart.
 *
 * The bulk panel is the crew grid and looks after itself — this file only switches panels and
 * runs the single-size control, which the theme no longer provides (this product template has
 * no variant_picker and no buy_buttons block).
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-buy-tabs]').forEach(function (root) {
    /* ── tabs ─────────────────────────────────────────────────────────── */
    var tabs = root.querySelectorAll('.fsbuy__tab');
    var panels = root.querySelectorAll('.fsbuy__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (pane) {
          var on = pane.dataset.panel === tab.dataset.tab;
          pane.classList.toggle('is-on', on);
          pane.hidden = !on;
        });
      });
    });

    /* ── the retail control ───────────────────────────────────────────── */
    var sizes = root.querySelectorAll('.fsbuy__size');
    var qty = root.querySelector('[data-retail-qty]');
    var add = root.querySelector('[data-retail-add]');
    var hint = root.querySelector('[data-retail-hint]');
    var status = root.querySelector('[data-retail-status]');
    if (!add || !qty) return;

    var chosen = null;
    var step = parseInt(qty.getAttribute('step'), 10) || 1;
    var busy = false;

    /* ── "why is this greyed out?" ───────────────────────────────────────────
       The button is aria-disabled rather than disabled (see pdp-buy-tabs.liquid), so a click
       on it still reaches us. Before 2026-09-23 it did not: a buyer who had not picked an
       option got the browser's red no-entry cursor and no sentence anywhere. Now the click is
       answered — say the missing step, and point at the control that takes it.
       The wording is the SAME sentence the hint under the button already carries, so the page
       does not say the same thing two ways. */
    function ready() { return add.getAttribute('aria-disabled') !== 'true'; }
    function setReady(on) { add.setAttribute('aria-disabled', on ? 'false' : 'true'); }
    /* ★ see pdp-crew-grid.js: the nudge is ours to withdraw, a failed add is not. */
    var asking = false;

    function askForOption() {
      asking = true;
      status.className = 'fsbuy__status is-err';
      status.textContent = hint && hint.textContent ? hint.textContent : 'Choose an option to continue.';
      var group = root.querySelector('.fsbuy__sizes');
      if (group) {
        group.classList.add('is-asking');
        setTimeout(function () { group.classList.remove('is-asking'); }, 1400);
      }
      var first = root.querySelector('.fsbuy__size:not([disabled])');
      if (first && typeof first.focus === 'function') first.focus();
    }

    /* ── everything that must follow the chosen variant ────────────────────
       This template has no variant_picker, so NOTHING in the theme hears about a
       selection made here. Before this, picking a colour changed only the small hint:
       the gallery kept showing variant one's photo and the rail kept showing variant
       one's part number. MEASURED on 280-ev6161 (9 variants, 9 distinct images) —
       image unchanged, rail unchanged, hint the only thing that moved.
       A trade buyer confirms the part number off that rail. Showing them someone
       else's is worse than showing nothing.
       ------------------------------------------------------------------------ */

    /* The theme's gallery keys media as `<sectionId>-<mediaId>`. The chip only carries
       the raw media id (a {% render %} snippet has no `section` in scope), so match on
       the tail rather than reconstruct the composite. */
    function showVariantMedia(mediaId) {
      if (!mediaId) return;
      var gallery = document.querySelector('media-gallery');
      var target = null;
      document.querySelectorAll('[data-media-id]').forEach(function (el) {
        if (!target && String(el.dataset.mediaId).split('-').pop() === String(mediaId)) target = el;
      });
      if (!target) return;
      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(target.dataset.mediaId, true);   // prepend: bring it to the front
      } else {
        /* No gallery custom element (or an older theme): fall back to activating the
           slide directly rather than doing nothing. */
        document.querySelectorAll('[data-media-id]').forEach(function (el) { el.classList.remove('is-active'); });
        target.classList.add('is-active');
        if (target.parentElement && target.parentElement.firstChild !== target) {
          target.parentElement.prepend(target);
        }
      }
    }

    var railSku = document.querySelector('[data-rail-sku]');
    var priceEl = root.querySelector('[data-retail-price]');
    /* Every OTHER place the part number is printed. Missing one is worse than missing all
       of them — a page showing two different part numbers for one selection reads as a
       fault in the data, not in the page. */
    var idlineSku = document.querySelector('[data-idline-sku]');
    var docSku = document.querySelector('[data-doc-sku]');

    sizes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        chosen = btn;
        sizes.forEach(function (s) { s.classList.toggle('is-on', s === btn); });
        setReady(true);
        if (asking) { asking = false; status.className = 'fsbuy__status'; status.textContent = ''; }
        // Naming the part number back to them is the confirmation a trade buyer wants; a
        // consumer ignores it harmlessly.
        hint.textContent = btn.dataset.sku ? 'Item ' + btn.dataset.sku : '';

        if (btn.dataset.sku) {
          if (railSku) railSku.textContent = btn.dataset.sku;
          if (idlineSku) idlineSku.textContent = 'Part #' + btn.dataset.sku;
          if (docSku) docSku.textContent = btn.dataset.sku;
        }
        if (priceEl && btn.dataset.priceHtml) priceEl.textContent = btn.dataset.priceHtml;
        showVariantMedia(btn.dataset.media);

        /* Put the variant in the URL so the selection survives a copy-paste or a refresh —
           the theme does this for its own picker and a buyer sending a colleague "this
           one" would otherwise send the default. replaceState, not pushState: choosing a
           colour is not a back-button step. */
        if (btn.dataset.variant && window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', btn.dataset.variant);
            history.replaceState({}, '', u.toString());
          } catch (e) { /* a malformed URL must not break adding to cart */ }
        }
      });
    });

    /* Land on the right variant when the URL names one (shared link, refresh, back). */
    (function preselectFromUrl() {
      try {
        var want = new URL(window.location.href).searchParams.get('variant');
        if (!want) return;
        for (var i = 0; i < sizes.length; i++) {
          if (sizes[i].dataset.variant === want && !sizes[i].disabled) { sizes[i].click(); return; }
        }
      } catch (e) { /* ignore */ }
    })();

    // The pack rule applies here exactly as it does in the grid — one control teaching a rule and
    // its neighbour ignoring it would be worse than neither.
    qty.addEventListener('blur', function () {
      var n = parseInt(qty.value, 10);
      if (!n || n < step) { qty.value = step; return; }
      if (step > 1 && n % step !== 0) qty.value = Math.ceil(n / step) * step;
    });

    add.addEventListener('click', function () {
      if (busy) return;
      if (!chosen || !ready()) { askForOption(); return; }
      var n = parseInt(qty.value, 10) || step;
      busy = true;
      setReady(false);
      var was = add.textContent;
      add.textContent = 'Adding…';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(chosen.dataset.variant, 10), quantity: n }] })
      })
        .then(function (r) { return r.json().then(function (bd) { return { ok: r.ok, body: bd }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'Could not add that');
          status.className = 'fsbuy__status is-ok';
          status.textContent = n + ' × ' + chosen.textContent.trim() + ' added to your cart.';
          return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.querySelectorAll('.cart-count-bubble').forEach(function (el) { el.hidden = false; });
        })
        .catch(function (err) {
          status.className = 'fsbuy__status is-err';
          status.textContent = err.message || 'We could not add that just now. Try again, or call us.';
        })
        .finally(function () { busy = false; setReady(Boolean(chosen)); add.textContent = was; });
    });
  });
})();

/* The bottom Description | Returns strip — same mechanic, different furniture. */
(function () {
  'use strict';
  document.querySelectorAll('[data-fstabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('.fstabs__tab');
    var panels = root.querySelectorAll('.fstabs__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (pane) {
          var on = pane.dataset.fspanel === tab.dataset.fstab;
          pane.classList.toggle('is-on', on);
          pane.hidden = !on;
        });
      });
    });
  });
})();
